import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest } from '@angular/common/http';

import { UserRegistration } from '../models/user.registration.interface';
import { ConfigService } from '../utils/config.service';

import { BaseService } from "./base.service";

import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/Rx';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';

 
//import * as _ from 'lodash';
import '../../rxjs-operators';

@Injectable()

export class UserService extends BaseService {

    baseUrl: string = '';

    // Observable navItem source
    private _authNavStatusSource = new BehaviorSubject<boolean>(false);
    // Observable navItem stream
    authNavStatus$ = this._authNavStatusSource.asObservable();

    private loginResult: any = {};
    private loggedIn = false;
    private processSec;
    private domainId = '';
    private currentUsername = '';
    private currentProcessRole = '';

    private errorMsg: any;

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.loggedIn = !!sessionStorage.getItem('auth_token');
    // ?? not sure if this the best way to broadcast the status but seems to resolve issue on page refresh where auth status is lost in
    // header component resulting in authed user nav links disappearing despite the fact user is still logged in
    this._authNavStatusSource.next(this.loggedIn);
    //this.baseUrl = configService.getApiURI();
    this.baseUrl = "api";
  }

  /*
  register(domainId: string, loginId: string, password: string, fullName: string, email: string, processRole: string, dataRole: string): Observable<UserRegistration> {
      let body = JSON.stringify({ domainId, loginId, password, fullName, email, processRole, dataRole });
      let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      //let options = new HttpRequest.headers.set(headers);
     
    
    return this.http.post(this.baseUrl + "/
      s1", body, { headers })
        .map(res => { return true;})
          .catch(err => {
              return Observable.of(err.json().login_result);
          });
          

  }
  */



    login(domainId, userNameInput, password) {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');

        let userInfo = userNameInput.split("\\");

        let userName = userNameInput;
        if (userNameInput.indexOf("\\") > -1) {
            userName = userInfo[1];
        }

        return this.http.post(this.baseUrl + '/BcpJwtAuth/login', JSON.stringify({ domainId, userName, password }), { headers }
            )
          .catch(err => {
            return Observable.throw(err.json().login_result);
          })
          .subscribe(res => {
                this.loginResult = res;
                sessionStorage.clear();
                sessionStorage.setItem('auth_token', this.loginResult.auth_token);
                sessionStorage.setItem('auth_token_long', this.loginResult.auth_token_long);
                sessionStorage.setItem('validFor', JSON.stringify(this.loginResult.validFor));
                sessionStorage.setItem('expiration', JSON.stringify(this.loginResult.expiration));
                sessionStorage.setItem('extendedExpiration', JSON.stringify(this.loginResult.expiration));

                sessionStorage.setItem('currentDomain', JSON.stringify(domainId));
                sessionStorage.setItem('currentUser', JSON.stringify(userName));
                sessionStorage.setItem('currentProcessRole', JSON.stringify(this.loginResult.processRole));
                sessionStorage.setItem('currentDataRole', JSON.stringify(this.loginResult.dataRole));
                
                sessionStorage.setItem('loggedIn', 'TRUE');

                this.loggedIn = true;
                this._authNavStatusSource.next(true);


                return true;
            })
            ;
    }

  renewToken() {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    let domainId = JSON.parse(sessionStorage.getItem('currentDomain'));
    let userName = JSON.parse(sessionStorage.getItem('currentUser'));
    let dataRole = JSON.parse(sessionStorage.getItem('currentDataRole'));
    let processRole = JSON.parse(sessionStorage.getItem('currentProcessRole'));
    let tokenExpiration = JSON.parse(sessionStorage.getItem('tokenExpiration'));
    let longTokenExpiration = JSON.parse(sessionStorage.getItem('longTokenExpiration'));
    let validFor = JSON.parse(sessionStorage.getItem('validFor'));
    let authToken = sessionStorage.getItem('auth_token');
    let authTokenLong = sessionStorage.getItem('auth_token_long');
 

    const utcDate = new Date();
    const newExpiration = validFor ? new Date(utcDate.getTime() + parseInt(validFor, 10) * 1000) : null;

    const body = JSON.stringify({ domainId, userName, dataRole, processRole });

    console.log('Renew Token Request Headers:', headers);
    console.log('Renew Token Request Body:', body);
    console.log('Renew Token Request URL:', "api" + '/BcpJwtAuth/renewToken');

    this.http.post("api/BcpJwtAuth/renewToken", body, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    }).subscribe((result: any) => {
      var res = JSON.parse(result);
      console.log("Renew is called");
      console.log("result " + res.auth_token);
      sessionStorage.setItem('currentDomain', JSON.stringify(domainId));
      sessionStorage.setItem('currentUser', JSON.stringify(userName));
      sessionStorage.setItem('currentProcessRole', JSON.stringify(res.processRole));
      sessionStorage.setItem('currentDataRole', JSON.stringify(res.dataRole));

      sessionStorage.setItem('auth_token', res.auth_token);
      sessionStorage.setItem('auth_token_long', res.auth_token_long);
      sessionStorage.setItem('validFor', JSON.stringify(res.validFor));
      sessionStorage.setItem('tokenExpiration', JSON.stringify(res.tokenExpiration));
      sessionStorage.setItem('longTokenExpiration', JSON.stringify(res.longTokenExpiration));
      sessionStorage.setItem('sessionExpiration', JSON.stringify(res.tokenExpiration));

      console.log("validFor " + JSON.parse(sessionStorage.getItem('validFor')));
      console.log("tokenExpiration " + JSON.parse(sessionStorage.getItem('tokenExpiration')));
      console.log("longTokenExpiration " + JSON.parse(sessionStorage.getItem('longTokenExpiration')));

      //tokenExpiration = JSON.stringify(res.expiration);

      let validFor = JSON.parse(sessionStorage.getItem('validFor'));

      let currentDateTime = new Date();
      let authToken = sessionStorage.getItem('auth_token');
      let sessionExpiration = JSON.parse(sessionStorage.getItem('sessionExpiration'));
      let tokenExpiration = JSON.parse(sessionStorage.getItem('tokenExpiration'));
      let longTokenExpiration = JSON.parse(sessionStorage.getItem('longTokenExpiration'));

      console.log("renew valid for          " + validFor);
      console.log("renew current date       " + currentDateTime.toJSON().slice(0, 19));
      console.log("renew tokenExpiration    " + tokenExpiration.slice(0, 19));
      console.log("renew longTokenExpiration " + longTokenExpiration.slice(0, 19));
      console.log("renew sessionExpiration 1     " + sessionExpiration);
      console.log("renew sessionExpiration 2      " + sessionExpiration.slice(0, 19));

    }), (error) => {
      let e1: any[];
      console.log("Error Renewing Token");
    };

  }

    renewTokenBackup() {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');

        let domainId = JSON.parse(sessionStorage.getItem('currentDomain'));
        let userName = JSON.parse(sessionStorage.getItem('currentUser'));
        let dataRole = JSON.parse(sessionStorage.getItem('currentDataRole'));
        let processRole = JSON.parse(sessionStorage.getItem('currentProcessRole'));
        let tokenExpiration = JSON.parse(sessionStorage.getItem('expiration'));
        let extendedExpiration = JSON.parse(sessionStorage.getItem('extendedExpiration'));
        let validFor = JSON.parse(sessionStorage.getItem('validFor'));
        let authToken = sessionStorage.getItem('auth_token');
        let authTokenLong = sessionStorage.getItem('auth_token_long');


        let utcDate = new Date();
        let newExpiration = new Date(utcDate.getTime() + validFor * 1000);


      return this.http.post(this.baseUrl + '/BcpJwtAuth/renewToken', JSON.stringify({ domainId, userName, dataRole, processRole }), { headers }
        )
          .catch(err => {
            return Observable.throw(err.json());
          })
          .subscribe(res => {
                sessionStorage.setItem('currentDomain', JSON.stringify(domainId));
                sessionStorage.setItem('currentUser', JSON.stringify(userName));
                sessionStorage.setItem('currentProcessRole', JSON.stringify(this.loginResult.processRole));
                sessionStorage.setItem('currentDataRole', JSON.stringify(this.loginResult.dataRole));

                sessionStorage.setItem('auth_token', this.loginResult.auth_token);
                sessionStorage.setItem('auth_token_long', this.loginResult.auth_token_long);
                sessionStorage.setItem('validFor', JSON.stringify(this.loginResult.validFor));
                sessionStorage.setItem('expiration', JSON.stringify(this.loginResult.expiration));
                sessionStorage.setItem('extendedExpiration', JSON.stringify(this.loginResult.expiration));

                tokenExpiration = JSON.parse(sessionStorage.getItem('expiration'));

                return true;
            })
            ;


    }


  logout(): void {
    console.log("Logout in user.services");
     sessionStorage.removeItem('auth_token');
     sessionStorage.removeItem('auth_token_long');
     sessionStorage.removeItem('validFor');
     sessionStorage.removeItem('expiration');
     sessionStorage.removeItem('extendedExpiration');

       sessionStorage.setItem('currentDomain', "");
       sessionStorage.setItem('currentUser', "");
       sessionStorage.setItem('currentProcessRole', "");
       sessionStorage.setItem('currentDataRole', "");
        this.loggedIn = false;
        this._authNavStatusSource.next(false);
    //this.getLoginStatus.emit(false);

  }

  getProcessRole() {
      return this.currentProcessRole
  }

  getSecProcess() {
      return this.processSec;
  }

  isLoggedIn() {
    return this.loggedIn;
  }  

     

}

interface ILoginResult {
}
